module.exports = __webpack_public_path__ + "media/phiphi/krabi-0c853e98.jpg";